import Glider from 'glider-js'

export default class TestimonialSlider {

    constructor($view) {
        this.$view = $view;
        this.$slider = this.$view.find('.js-slides');
        this.bind();
    }

    bind() {

        new Glider(this.$slider[0], {
            draggable: true,
            scrollLock: true,
            responsive: [
                {
                    breakpoint: 0,
                    settings: {
                        slidesToShow: 1.5
                    }
                },
                {
                    breakpoint: 676,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 868,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4
                    }
                }
            ]
        });

    }

}